import React from "react";
import { Link } from "react-router-dom";
import { Plus } from "lucide-react";
import { useEnquiryCart } from "@/contexts/EnquiryCartContext";
import { toast } from "sonner";

export default function ProductCard({ product }) {
    const { addItem } = useEnquiryCart();
    const front = product.images?.[0];
    const back = product.images?.[1] || product.images?.[0];

    const handleAdd = (e) => {
        e.preventDefault();
        e.stopPropagation();
        addItem(product, 1);
        toast.success("Added to enquiry", { description: product.name });
    };

    return (
        <div className="group" data-testid={`product-card-${product.sku}`}>
            <Link to={`/product/${product.id}`} className="block">
                <div className="relative aspect-[4/5] overflow-hidden bg-ivory product-hover">
                    <img src={front} alt={product.name} className="front w-full h-full object-cover" loading="lazy" />
                    <img src={back} alt="" className="back w-full h-full object-cover" loading="lazy" />
                    <button
                        onClick={handleAdd}
                        data-testid={`product-card-add-${product.sku}`}
                        aria-label="Add to enquiry"
                        className="absolute bottom-3 left-1/2 -translate-x-1/2 opacity-0 group-hover:opacity-100 transition-opacity duration-300 bg-paper text-ink border border-bronze hover:bg-ink hover:text-paper text-[10px] uppercase tracking-[0.22em] px-5 py-2.5 flex items-center gap-2"
                    >
                        <Plus size={12} /> Add to Enquiry
                    </button>
                </div>
            </Link>
            <Link to={`/product/${product.id}`} className="block mt-3 text-center">
                <h3 className="font-serif text-lg leading-tight text-ink">{product.name}</h3>
                <p className="mt-1 text-[11px] uppercase tracking-[0.2em] text-muted-ink">
                    {product.purity}{product.weight_grams > 0 ? ` · ${product.weight_grams}g` : ""}
                </p>
                <p className="mt-1 text-[10px] uppercase tracking-[0.24em] text-bronze-deep">Enquire on WhatsApp</p>
            </Link>
        </div>
    );
}
